import React, { useState, useEffect } from "react";
import moment from "moment";
import { IoIosClose } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const customStyles = {
	"--react-datepicker-time-list-bg": "white",
};
const DateandTimePicker = ({
	date,
	isModalOpen,
	setIsModalOpen,
	setRequestSent,
	propertyEarlyCheckInTime,
	propertyTime,
	propertyTimeZone,
	addon,
}) => {
	console.log(
		"DateandTimePicker rendered with date:",
		propertyEarlyCheckInTime,
	);
	const [selectedDate, setSelectedDate] = useState(null);
	const [selectedTime, setSelectedTime] = useState("");
	const [timeSlots, setTimeSlots] = useState([]);

	// Convert 24hr to 12hr format
	const convert24to12 = (time24) => {
		return moment(time24, "HH:mm").format("hh:mm A");
	};

	const generateTimeSlots = (start, end, intervalMinutes) => {
		const slots = [];
		let current = new Date(start);
		const endDate = new Date(end);

		while (current <= endDate) {
			// Convert directly to 12-hour format
			const time12 = moment(current).format("hh:mm A");
			slots.push(time12);
			current.setMinutes(current.getMinutes() + intervalMinutes);
		}
		console.log(slots);
		return slots;
	};

	useEffect(() => {
		const now = new Date();
		// Convert propertyTime from 24hr to 12hr format
		const propertyTime12 = convert24to12(propertyTime || "00:00");
		const [propertyHour, propertyMinute] = moment(propertyTime12, "hh:mm A")
			.format("HH:mm")
			.split(":")
			.map(Number);

		const startTime = new Date();
		startTime.setHours(propertyHour, propertyMinute, 0);

		let slots = [];

		if (!propertyEarlyCheckInTime?.defaultTimeEnabled) {
			const endTime = new Date();
			const defaultEndTime = new Date();
			defaultEndTime.setHours(22, 0, 0); // 10:00 PM

			// Convert defaultTiming to 12hr format
			const defaultTime12 = convert24to12(
				propertyEarlyCheckInTime.defaultTiming,
			);
			const [defaultHour, defaultMinute] = moment(defaultTime12, "hh:mm A")
				.format("HH:mm")
				.split(":")
				.map(Number);

			endTime.setHours(defaultHour, defaultMinute, 0);

			const finalEndTime = endTime > defaultEndTime ? defaultEndTime : endTime;
			slots = generateTimeSlots(startTime, finalEndTime, 60);
		} else if (propertyEarlyCheckInTime?.defaultTiming) {
			// Convert customTiming to 12hr format
			const customTime12 = convert24to12(
				propertyEarlyCheckInTime.defaultTiming,
			);
			const [customHour, customMinute] = moment(customTime12, "hh:mm A")
				.format("HH:mm")
				.split(":")
				.map(Number);

			const endTime = new Date();
			endTime.setHours(customHour, customMinute, 0);

			slots = generateTimeSlots(endTime, startTime, 15);
		}

		// Filter out the propertyTime12 from the time slots
		slots = slots.filter((slot) => slot !== propertyTime12);

		setTimeSlots(slots);
		setSelectedTime(slots.length > 0 ? slots[0] : "");

		//console.log("Time Slots: ", slots);
	}, [propertyTime, propertyEarlyCheckInTime]);

	return (
		<div
			className={`fixed bottom-0 left-0 w-full bg-white p-4 shadow-lg transition-transform transform ${
				isModalOpen ? "translate-y-0" : "translate-y-full"
			} h-80`}
			style={{ zIndex: 9999 }}
		>
			<div className="flex items-center justify-between pb-4">
				<div className="text-lg text-black">Early check-in date and time</div>
				<button
					onClick={(e) => {
						e.preventDefault();
						setIsModalOpen(false);
					}}
				>
					<IoIosClose className="h-8 w-8 text-black" />
				</button>
			</div>

			<div className="flex items-center justify-center bg-white">
				<input
					value={`On ${moment(date).format("MM-DD-YYYY")}`}
					placeholderText="Select Date"
					className="w-full px-10 py-3 border border-gray-400 rounded-md text-lg text-black"
					popperClassName="custom-datepicker"
					style={customStyles}
					disabled={true}
				/>
			</div>

			<div className="mb-4 text-lg text-center">
				<div className="text-left text-black">
					Select Time: {propertyTimeZone}
				</div>
				{timeSlots.length > 0 ? (
					<select
						value={selectedTime}
						onChange={(e) => setSelectedTime(e.target.value)}
						className="w-full mt-2 px-4 py-2 border border-gray-400 rounded-md text-black"
					>
						<option value="" disabled className="text-black">
							Select Time {propertyTimeZone}
						</option>
						{timeSlots.map((slot, index) => (
							<option key={index} value={slot} className="text-black">
								{slot}
							</option>
						))}
					</select>
				) : (
					<div className="text-black">No available time slots</div>
				)}
			</div>

			<button
				className="w-full py-2 mt-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50"
				onClick={(e) => {
					e.preventDefault();
					setRequestSent(selectedTime); // Sending 12hr format to parent
					setIsModalOpen(false);
				}}
			>
				Send Request {addon && addon.price ? `($${addon?.price})` : ""}
			</button>
		</div>
	);
};

export default DateandTimePicker;
